<div
  class="flow-helper-text"
  [class.flow-helper-text--destructive]="isDestructive"
  [class.flow-helper-text--success]="isSuccess"
  [class.flow-helper-text--flash]="flashSignal()"
>
  @if (helperText) {
    <div class="flow-helper-text__left">
      @if (showIcon) {
        <span class="flow-helper-text__icon">
          <img [src]="icon" alt="" aria-hidden="true" role="presentation" />
        </span>
      }
      <span
        [id]="textId"
        class="flow-helper-text__text caption-1"
        [attr.role]="isDestructive ? 'alert' : null"
        [attr.aria-live]="textLiveSetting"
      >{{ helperText }}</span>
    </div>
  }

  @if (showCount) {
    <span [id]="countId" class="flow-helper-text__count caption-1" [attr.aria-live]="countLiveSetting">{{ characterCount }}/{{ maxCount }}</span>
  }
</div>
